module.exports = __webpack_public_path__ + "static/media/dinosaur(26).be0c23e9.PNG";